/**
 * collections.js
 * Centralized Firestore collection names
 * Use these constants instead of hardcoded strings
 */

export const COLLECTIONS = {
  // Users & Auth
  USERS: 'users',

  // Classes & Learning
  CLASSES: 'classes',
  LESSONS: 'lessons',
  SYLLABUS: 'syllabus',
  SUBJECTS: 'subjects',

  // Assignments & Submissions
  ASSIGNMENTS: 'assignments',
  SUBMISSIONS: 'submissions',

  // Exams
  EXAMS: 'exams',
  EXAM_RESULTS: 'examResults',
  QUESTIONS: 'questions',
  QUESTION_BANK: 'questionBank',

  // Progress & Grades
  GRADES: 'grades',
  ATTENDANCE: 'attendance',
  PROGRESS: 'progress',

  // PCAP Module
  PCAP_LO_THEORY: 'pcap_lo_theory',
  PCAP_PRACTICE: 'pcap_practice',
  PCAP_PROGRESS: 'pcap_progress',
  PCAP_BADGES: 'pcap_badges',

  // Reports & Analytics
  REPORTS: 'reports',
  EVALUATIONS: 'evaluations',

  // Notifications
  NOTIFICATIONS: 'notifications',

  // Student Care — case can thiệp + yêu cầu hỗ trợ học sinh tự gửi
  RISK_CASES: 'risk_cases',

  // Portfolio
  PORTFOLIOS: 'portfolios',
  PROJECTS: 'projects',

  // Capstone
  CAPSTONE_PROJECTS: 'capstone_projects',
  CAPSTONE_SUBMISSIONS: 'capstone_submissions',

  // Schedule
  SCHEDULES: 'schedules',
  EVENTS: 'events',
};

// Collection group queries (cross-collection queries)
export const COLLECTION_GROUPS = {
  ALL_PROGRESS: 'all_progress',
  ALL_SUBMISSIONS: 'all_submissions',
};

export default COLLECTIONS;